<template>
  <ul v-if="isFolder" class="table__row -folder-row-" @click.self="$emit('click')">
    <li class="table__col" :style="{ paddingLeft: paddingLeft + 'px' }" @click="$emit('click')">
      <div class="table__text table__text-folder">
        <div class="table___text -folder-name-">{{ data.name }}</div>
        <div class="table__text-folder-point">
          <Icon
            class="form-item__icon select__icon"
            icon="arrow-down-thick"
            :class="{ '-opened-': isOpen }"
          ></Icon>
        </div>
      </div>
    </li>
    <li class="table__col" @click="$emit('click')">
      <p class="table__text">{{ count }}</p>
    </li>
    <li class="table__col" @click.self="$emit('click')">
      <div ref="tableaction" class="table__actions">
        <Button
          v-if="$permissionsCreate"
          class="-xs-"
          color="button-transparent"
          @click="openCreateGroup"
        >
          <Icon class="icon-plus" icon="plus-circle"></Icon>Добавить группу
        </Button>
        <Icon v-if="$permissionsUpdate" class="pointer" icon="edit" @click="openFolder"></Icon>
        <Icon
          v-if="$permissionsDelete"
          class="pointer"
          icon="delete"
          @click="clickAction('deleteFolder')"
        ></Icon>
      </div>
      <transition v-if="confirm" name="fadePreloader">
        <Confirm
          v-model="selected"
          class="table__confirm-action"
          :parent="$refs.tableaction"
          :is-open.sync="confirm"
          :selected-field="selectedField"
        ></Confirm>
      </transition>
    </li>
  </ul>
  <div v-else style="width: 100%">
    <ul class="table__row -group-row-">
      <li
        class="table__col -group-name-col-"
        :style="{ paddingLeft: paddingLeft + 'px' }"
        @click="userListIsOpen = !userListIsOpen"
      >
        <p class="table__text">{{ data.name }}</p>
        <div class="table__text-folder-point">
          <Icon
            class="form-item__icon select__icon"
            icon="arrow-down-thick"
            :class="{ '-opened-': userListIsOpen }"
          ></Icon>
        </div>
      </li>
      <li class="table__col">
        <p class="table__text">{{ data.count }}</p>
      </li>
      <li class="table__col">
        <div ref="tableaction" class="table__actions">
          <Icon
            v-if="checkPermission({ key: 'userModuleAdmin', type: 'read' })"
            class="pointer"
            icon="user-group"
            @click="goToGroupUsers"
          ></Icon>
          <Icon v-if="$permissionsUpdate" class="pointer" icon="edit" @click="openGroup"></Icon>
          <Icon
            v-if="$permissionsDelete"
            class="pointer"
            icon="delete"
            @click="clickAction('delete')"
          ></Icon>
        </div>
        <transition v-if="confirm" name="fadePreloader">
          <Confirm
            v-model="selected"
            class="table__confirm-action"
            :parent="$refs.tableaction"
            :is-open.sync="confirm"
            :selected-field="selectedField"
          ></Confirm>
        </transition>
      </li>
    </ul>
    <UsersList v-if="userListIsOpen" :group="data"></UsersList>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import { mapState } from 'vuex';
import getPermissionGropus from '@/constants/permissions/getPermissionGropus';
import UsersList from './UsersList';

export default {
  components: { UsersList },
  directives: { clickOutside: vClickOutside.directive },
  props: ['data', 'isFolder', 'isOpen', 'count', 'paddingLeft', 'parentFolder', 'folder'],
  data() {
    return {
      userListIsOpen: false,
      action: '',
      selected: '',
      selectedField: '',
      confirm: false,
      promiseInterval: '',
      optionsFields: {
        update: {
          text: 'Редактировать',
          func: this.openGroup,
          icon: 'edit'
        },
        goTo: {
          text: 'Перейти к пользователям',
          func: this.goToGroupUsers,
          icon: 'user-unknown'
        },
        delete: {
          text: 'Удалить',
          func: this.deleteGroup,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить группу?',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        },
        deleteFolder: {
          text: 'Удалить',
          func: this.deleteFolder,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle:
            'Вы уверены, что хотите удалить папку? Удалятся все её папки, а также пользователи из групп',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        }
      }
    };
  },
  computed: {
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userGroupModuleAdmin,
      $otherPermissions: s => s.data.user.permissions,
      isAdmin: s => s.data.user.permissions.isAdmin
    })
  },
  methods: {
    async clickAction(action) {
      let result;
      this.confirm = true;
      this.selectedField = this.optionsFields[action];
      result = await new Promise((res, rej) => {
        this.promiseInterval = setInterval(() => {
          if (this.selected === 'success') {
            res('next');
          } else if (this.selected === 'cancel') {
            res('cancel');
          }
        }, 50);
      });

      this.clearConfirmData();

      if (result === 'cancel') {
        return;
      } else {
        this.optionsFields[action].func();
      }
    },
    clearConfirmData() {
      this.confirm = false;
      this.selected = '';
      if (this.promiseInterval) {
        clearInterval(this.promiseInterval);
      }
    },
    openGroup() {
      const value = {
        ...this.data
      };
      if (this.folder) {
        value.folderId = this.folder.id;
      }

      this.$store.dispatch('usersGroups/setAsideData', {
        path: 'group',
        value
      });
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    goToGroupUsers() {
      this.$router.push({ path: `/users/group/${this.data.id}/users` });
    },
    deleteGroup() {
      this.$store.dispatch('usersGroups/deleteGroup', { group: this.data });
    },
    openCreateGroup() {
      this.$store.dispatch('usersGroups/setAsideData', {
        path: 'group',
        value: {
          name: '',
          folderId: this.data.id,
          courses: [],
          courseFolders: [],
          count: 0,
          permissions: {
            isAdmin: false,
            ...getPermissionGropus()
          }
        }
      });
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    openFolder() {
      const value = {
        ...this.data
      };

      if (this.parentFolder) {
        value.parentId = this.parentFolder.id;
      }

      this.$store.dispatch('usersGroups/setAsideData', {
        path: 'folder',
        value
      });
      this.$store.dispatch('usersGroups/setAsideMeta', {
        path: 'isOpen',
        value: true
      });
    },
    deleteFolder() {
      this.$store.dispatch('usersGroups/deleteFolder', { folder: this.data });
    }
  }
};
</script>
